import React from 'react';

import { useAlerts } from '@hooks/useAlerts';

import type { AlertType } from '@customTypes/alert';
import { Alert } from './Alert';

export function Alerts() {
  const { alerts } = useAlerts();

  return (
    <>
      {alerts.map((alert: AlertType) => (
        <Alert key={`Alert-${alert.key}`} alert={alert} />
      ))}
    </>
  );
}
